import axios from "axios";

const API_ENDPOINT = "https://www.googleapis.com/youtube/v3/playlists";

const DESCRIPTION = "This playlist is generated by Youtube Playlist Generator";

type Privacy = "private" | "unlisted" | "public";

const createNewPlayList = async (
  title: string,
  accessToken: string,
  privacy: Privacy = "private"
) => {
  const data = await axios.post(
    `${API_ENDPOINT}?access_token=${accessToken}&part=snippet,status&resource.snippet.title=${encodeURIComponent(
      title
    )}&resource.snippet.description=${encodeURIComponent(
      DESCRIPTION
    )}&resource.status.privacyStatus=${privacy}`
  );
  return data;
};

const addToPlayList = async (
  accessToken: string,
  playlistId: string,
  vid: string
) => {
  await axios.post(
    `https://www.googleapis.com/youtube/v3/playlistItems?access_token=${accessToken}&part=snippet&resource.snippet.playlistId=${playlistId}&resource.snippet.resourceId.videoId=${vid}&resource.snippet.resourceId.kind=youtube%23video`
  );
};

export { createNewPlayList, addToPlayList };
export type { Privacy };
